import { catchError, map, Observable, of, tap } from 'rxjs';
import { ComponentDataSourceService } from '../../component-data-source.service';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { RLSTableDTO } from '../../../../dto/rls/rls-table.dto';
import { environment } from '../../../../environment/environment';

export function rls_tables(componentDataSourceService: ComponentDataSourceService) {
    return {
        name: 'RLS Tables',
        description: 'Lists all PostgreSQL tables with their RLS status',
        execute: (params?: LoadDataParams) => {
            
            return componentDataSourceService.http.get<RLSTableDTO[]>(
                `${environment.apiUrl}/rls/tables`,
                params?.queryParams ? { params: params.queryParams } : {}
            ).pipe(
                catchError(error => {
                    console.error('Error fetching RLS tables:', error);
                    return of([]);
                }),
                map(tables => ({
                    items: tables,
                    totalCount: tables.length
                }))
            );
        },
        settings: {
            columns: [
                { key: 'table_name', header: 'Table Name', type: 'text' },
                { key: 'has_rls', header: 'Has RLS', type: 'boolean' },
                { key: 'force_rls', header: 'Force RLS', type: 'boolean' },
                { key: 'public_grants', header: 'Public Grants', type: 'text' }
            ],
            pageable: true,
            sortable: true,
            rowHover: true,
            defaultSortColumn: 'table_name',
            defaultSortDirection: 'asc'
        }
    }
} 